export default __webpack_public_path__ + "static/media/world_trade_interior.5007437f.jpg";